import { useRef } from 'react';

import { useEvaluationId } from '../../../hooks/use-evaluation-id';
import { useFeedback } from '../../../hooks/use-feedback';
import { Feedback } from '../../../lib';

export const useViewFeedback = () => {
	const evaluationRef = useRef<Feedback | undefined>();
	const { evaluationId, clearId } = useEvaluationId();
	const isOpen = !!evaluationId;
	const { data: evaluation, error, isLoading } = useFeedback(evaluationId);

	// Store the evaluation in a ref so it can still be accessed after the query param
	// is removed from the URL
	if (evaluation) {
		evaluationRef.current = evaluation;
	}

	return {
		error,
		evaluation: evaluation || evaluationRef.current,
		isLoading,
		isOpen,
		onClose: clearId,
	};
};
